var exports = {
  "k": "x0a7806d5--09f0fa--container",
};

module.exports = exports;
